<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="contact-dialog">
    <div class="contact__dialog-header" *ngIf="!isSearchView">
        <div class="mobile-back-button">
            <button mat-button (click)="close()">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            {{ 'LIST_LABEL' | translate }}
        </div>
        <div class="mobile-back-button" (click)="openSearchView(true)">
            <button mat-button>
                <mat-icon class="disable-select">search</mat-icon>
            </button>
        </div>
    </div>
    <div class="contact__dialog-header search-header" *ngIf="isSearchView">
        <div class="mobile-back-button">
            <button mat-button (click)="openSearchView(false)">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            <mat-form-field floatLabel="never">
                <input matInput #searchTextInput class="form-control" [(ngModel)]="searchText" name="label"
                    placeholder="{{ 'SEARCH_LISTS' | translate }}" autocomplete="nope" />
            </mat-form-field>
        </div>
        <div class="mobile-back-button">
            <button mat-button *ngIf="searchText.length > 0" (click)="emptySearchText()">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="contact__dialog-body">
        <div class="content">
            <div *ngFor="let list of contactFolders | vpListsSearch : searchText" class="folder-list-item"
                vpLongPress [timeout]="700" (onLongPress)="$event.preventDefault(); $event.stopPropagation(); openListOperationMenu(list)" (click)="routeToContactListFolder(list)">
                <div class="disable-select">
                    <mat-icon [style.color]="(list.color_hex) ? list.color_hex : '#888'" class="mdi-20px" fontSet="mdi" fontIcon="mdi-account-box-multiple"></mat-icon>
                </div>
                <div class="name disable-select">
                    {{ list.name}}
                </div>
                <div class="count disable-select">
                    {{ list.contacts_count }}
                </div>
            </div>
        </div>
    </div>
</div>
<vp-contact-operation-button (buttonClick)="addList()"></vp-contact-operation-button>